import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNeutralFace = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 0C5.59476 0 0 5.59476 0 12.5C0 19.4052 5.59476 25 12.5 25C19.4052 25 25 19.4052 25 12.5C25 5.59476 19.4052 0 12.5 0ZM12.5 22.5806C6.94052 22.5806 2.41935 18.0595 2.41935 12.5C2.41935 6.94052 6.94052 2.41935 12.5 2.41935C18.0595 2.41935 22.5806 6.94052 22.5806 12.5C22.5806 18.0595 18.0595 22.5806 12.5 22.5806ZM8.46774 11.6935C9.35988 11.6935 10.0806 10.9728 10.0806 10.0806C10.0806 9.18851 9.35988 8.46774 8.46774 8.46774C7.5756 8.46774 6.85484 9.18851 6.85484 10.0806C6.85484 10.9728 7.5756 11.6935 8.46774 11.6935ZM16.5323 8.46774C15.6401 8.46774 14.9194 9.18851 14.9194 10.0806C14.9194 10.9728 15.6401 11.6935 16.5323 11.6935C17.4244 11.6935 18.1452 10.9728 18.1452 10.0806C18.1452 9.18851 17.4244 8.46774 16.5323 8.46774ZM16.9355 15.7258H8.06452C7.39919 15.7258 6.85484 16.2702 6.85484 16.9355C6.85484 17.6008 7.39919 18.1452 8.06452 18.1452H16.9355C17.6008 18.1452 18.1452 17.6008 18.1452 16.9355C18.1452 16.2702 17.6008 15.7258 16.9355 15.7258Z",
		fill: "currentColor"
	})
});
export default SvgNeutralFace;
